import {
  useActions as useLoadActions,
  selectors as loadSelectors,
} from '../../store/Reports/TransactionsDataSlice';

const useTransactionsData = () => {
  const { load: loadTransactionsData } = useLoadActions();
  const { getData, getLoadingState } = loadSelectors;
  const transactionsData = getData();
  const transactionsDataLoadingState = getLoadingState();

  return {
    transactionsData,
    loadTransactionsData,
    transactionsDataLoadingState,
  };
};

export default useTransactionsData;
